<template>
  <div>
    <h2>Lugar de Procedencia</h2>
    <app-ubigeo
      ref="ubigeo"
      :regions="regions"
      :provinces="provinces"
      :districts="districts"
      @changed="ubigeoCambiado"
    />
    <v-layout wrap>
      <v-flex
        sm12
        xs12
      >
        <v-text-field
          v-model="form.origin_address"
          label="DIRECCION DE ORIGEN"
          :rules="rules.origin_address"
          :error="!!formErrors.origin_address"
          :error-messages="formErrors.origin_address"
          @keyup="
            () => {
              formErrors.origin_address = undefined;
              delete formErrors.origin_address;
            }
          "
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AppUbigeo from './ubigeo'
export default {
  name: 'AppLugarProcedencia',
  components: { AppUbigeo },
  props: {
    data: {
      required: true, type: Object
    },
    regions: {
      required: true, type: Array
    },
    provinces: {
      required: true, type: Array
    },
    districts: {
      required: true, type: Array
    }
  },
  data () {
    return {
      formErrors: {},
      form: {
        origin_region: '',
        origin_province: '',
        origin_district_id: '',
        origin_address: ''
      },
      rules: {
        origin_address: [
          v => !!v || 'Su direccion de procedencia es requerido.'
        ]
      }
    }
  },
  computed: {
    validForm () {
      return !!this.$refs.ubigeo && !!this.form.origin_address
    }
  },
  watch: {
    'form.origin_region': function (val) {
      this.$refs.ubigeo.form.region = val
    },
    'form.origin_province': function (val) {
      this.$refs.ubigeo.form.province = val
    },
    'form.origin_district_id': function (val) {
      this.$refs.ubigeo.form.district = val
    }
  },
  methods: {
    ubigeoCambiado (ubigeo) {
      [this.form.origin_region, this.form.origin_province, this.form.origin_district_id] =
        [ubigeo.region, ubigeo.province, ubigeo.district]
    }
  }
}

</script>
